module.exports = __webpack_public_path__ + "static/media/guy.231e99aa.jpg";